import {
  combineSlices,
  configureStore,
} from "@reduxjs/toolkit";
import { useDispatch, useSelector, Provider } from "react-redux";
import { dynamicMiddleware } from "./dynamicMiddleware.js";

export interface LazyLoadedSlices {
  //
}
export const rootReducer =
  combineSlices().withLazyLoadedSlices<LazyLoadedSlices>();
export type RootReducer = typeof rootReducer;

export function createStore() {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().prepend(dynamicMiddleware.middleware),
    devTools: {
      maxAge: 1000,
    }
  });

  return store;
}

export type AppStore = ReturnType<typeof createStore>;
export type RootState = ReturnType<RootReducer>;
export type AppDispatch = AppStore["dispatch"];
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export { Provider };